export type TerminalSession = {
  id: string;
  name: string;
  initialCommand?: string;
  env?: Record<string, string>;
};

export function backgroundOutputFile(output: string): string | null {
  return output.match(/output is being written to:\s*(\/\S+\.output)/i)?.[1] ?? null;
}
